import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ElectricalConfiguration, MeteringConfiguration, SiteData, SiteStatus } from '../../api/api-site';
import { OperatingStatus } from '../../api/api-site-alerts';
import { RootState } from '../../app/store';

export const DEFAULT_SITE_DATA: SiteData = {
  clipsal_solar_id: 0,
  distributor_id: 0,
  electrical_config: '' as ElectricalConfiguration,
  metering_configuration: '' as MeteringConfiguration,
  roof_type: '',
  retailer_id: 0,
  site_name: '',
  site_city: '',
  site_country: '',
  site_state: '',
  site_zipcode: '',
  site_latitude: '',
  site_longitude: '',
  site_address_line1: '',
  street_address: '',
  timezone: '',
  tenant: {
    tenant_id: 0,
    tenant_name: '',
    address: null,
    city: null,
    country: null,
    logo_url: null,
    state: null,
    zipcode: null,
  },
  users: [],
  site_address_line2: null,
  site_address_line3: '',
  flagged: null,
  is_consumption_only: false,
  has_pulse: false,
  has_solar: false,
  install_date: '',
  has_battery: false,
  solar_capacity_kw: 0,
  commissioning_status: '' as SiteStatus,
  operating_status: 'normal' as OperatingStatus,
  block_third_party_updates: false,
};

const initialState = {
  clipsal_solar_id: null as number | null,
};

export const siteSlice = createSlice({
  name: 'site',
  initialState,
  reducers: {
    setSiteId: (state, action: PayloadAction<number | null>) => {
      state.clipsal_solar_id = action.payload;
    },
    reset: () => {
      return initialState;
    },
  },
});

export const { setSiteId, reset } = siteSlice.actions;

export const selectSiteId = (state: RootState) => {
  return state.site.clipsal_solar_id;
};

export const { reducer: siteReducer } = siteSlice;
